// extracted by mini-css-extract-plugin
module.exports = {"floating":"styles_floating__KqNWP","floatingHidden":"styles_floatingHidden__lPaM4"};